import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { VeeValidatePlugin } from "@/plugins/vee-validate";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { AxiosPlugin } from "@/plugins/axios";
import Vue2Filters from "vue2-filters";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { VueMaskDirective } from "v-mask";

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import es from "vee-validate/dist/locale/es.json";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(Vue2Filters);

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VeeValidatePlugin);

Vue.use(AxiosPlugin);
Vue.directive("mask", VueMaskDirective);
// install rules
Object.keys(rules).forEach((rule) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  extend(rule, rules[rule]);
});

localize("es", es);

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
